import React, { useEffect, useRef, useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import axios from "axios";

const Packshot = ({image}) => {
//   const get_packshot_url = (image) => {
//     return (
//       `https://caiproduction002.blob.core.windows.net/ira/compressed_packshots/` +
//       image +
//       `?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D`
//     );
//   };
  const get_packshot_url = async (image) => {
	try {
		const urlData = await axios.post("/get_context/getImageURL", {
			"imageName": image,
			"folderName":"compressed_packshots"
		})
		const imageUrl = urlData.data;
		console.log(imageUrl,"LINE 51")
		return imageUrl
	} catch (error) {
		console.error("Error fetching image:", error.message);
		return null;
	}
};

 
  //const [packshot,setPackshot]=useState(null);
  const [loading,setLoading]=useState(false);
  const packshotUrl =get_packshot_url(image);

  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      context.clearRect(0, 0, canvas.width, canvas.height); // Clearing the canvas before drawing the new image
      const aspectRatio = img.width / img.height;
      const canvasAspectRatio = canvas.width / canvas.height;

      let drawWidth = canvas.width;
      let drawHeight = canvas.height;

      if (aspectRatio > canvasAspectRatio) {
        drawHeight = canvas.width / aspectRatio;
      } else {
        drawWidth = canvas.height * aspectRatio;
      }
      const x = (canvas.width - drawWidth) / 2;
      const y = (canvas.height - drawHeight) / 2;
      context.drawImage(img, x, y, drawWidth, drawHeight);
     
    };

    img.src = packshotUrl;
  }, [packshotUrl]);

  return (
    <div style={{ position: 'relative', width: '200px', height: '170px' }}>
      {loading && <CircularProgress style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />}
      <canvas
        ref={canvasRef}
        width={200}
        height={170}
        style={{ display: loading ? 'none' : 'block', width: '200px', height: '170px' }}
      />
    </div>

  );
};

export default Packshot;
